import * as React from "react";
import ReactModal from "react-modal";
import { useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../reducer/action";
import { getModalStoreSelector } from "../reducer/selectors";
import modalTypes from "./modal-types";

const MODAL_TYPES = {
  alert: modalTypes.alertModal,
  loading: modalTypes.loadingModal,
  expiredAlert: modalTypes.expiredAlertModal,
  multiAction: modalTypes.multiActionModal,
  updateAppModal: modalTypes.updateAppModal,
};

const ModalContainer = () => {
  const { colors } = useTheme();
  const { modalProps, modalType } = useSelector(getModalStoreSelector);
  const [modalIsOpen, setModalIsOpen] = React.useState(modalProps.open);
  const dispatchStore = useDispatch();
  const closeModal = React.useCallback(() => {
    dispatchStore(hideModal());
  }, [dispatchStore]);

  React.useEffect(() => {
    setModalIsOpen(modalProps.open);
  }, [modalProps.open]);

  const SpecifiedModal = MODAL_TYPES[modalType];

  return (
    <React.Fragment>
      <ReactModal
        style={{
          overlay: {
            zIndex: 9999,
            position: "fixed",
            backgroundColor: colors.backdrop,
          },
          content: {
            top: "50%",
            borderRadius: 24,
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: modalType !== "loading" ? modalType === "updateAppModal" ? 360 : 500 : "auto",
            maxWidth: "80%",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Modal"
        ariaHideApp={false}>
        <SpecifiedModal closeModal={closeModal} {...modalProps} />
      </ReactModal>
    </React.Fragment>
  );
};
export default ModalContainer;
